<gd-dialog-container [class]="size" (close)="close()">
  <div class="header no-border" data-lokalise data-key="txt_setup_platform_costs"></div>
  <div *ngIf="loading$ | async" class="loading"></div>
  <div *ngIf="!(loading$ | async)" class="ui form" [formGroup]="platformCostsForm">
    <div formArrayName="platformCosts">
      <div *ngFor="let item of platformCosts.controls; let i = index" class="platform-costs">
        <div class="platform-costs-legend">
          <div
            [innerHTML]="
              'txt_pn_setup_store_costs'
                | translate: { storeType: stores[i].type | storeType | async, storeName: stores[i].name }
            "
          ></div>
          <!-- Keep hidden till we have our own articles for all platforms -->
          <!-- <a [innerHTML]="'txt_how_to_setup_platform_costs' | translate: { platformName: stores[i].type }"></a> -->
        </div>
        <gd-platform-cost-control [currency]="currency" formControlName="{{ i }}"></gd-platform-cost-control>
      </div>
    </div>
  </div>
  <div class="actions">
    <button
      class="ui secondary button"
      [disabled]="actionButtonsDisabled$ | async"
      (click)="close()"
      data-lokalise
      data-key="txt_cancel"
    ></button>
    <button
      class="ui primary button"
      [disabled]="actionButtonsDisabled$ | async"
      (click)="choose()"
      data-lokalise
      data-key="txt_choose"
    ></button>
  </div>
</gd-dialog-container>
